import styled from 'styled-components'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import ProjectCard from 'student/projects/project-card'
import { useProject } from 'querys/projects'

const SendToRevisionStyled = styled.section`
  margin-block-end: 80px;
  .sender-container {
    margin-block-start: 40px;
  }
  .student-project-card {
    transition: 0.3s ease-in opacity;
    opacity: ${({ started }) => (started ? 1 : 0.5)};
  }
  .revision-steps {
    padding: 0;
    list-style: none;
  }
  .revision-step {
    font: var(--regular);
    font-weight: 400;
    margin-block-end: 24px;
    span {
      font-weight: 700;
      min-inline-size: 24px;
      display: inline-block;
      color: var(--turquoise);
      margin-inline-end: 8px;
    }
  }
  @media (min-width: 1024px) {
    .revision-step {
      font: var(--headline5);
      font-weight: 400;
    }
    .sender-container {
      display: flex;
      justify-content: space-between;
      gap: 84px;
    }
    .student-project-card {
      flex: 1;
    }
    .revision-steps {
      flex: 1;
    }
  }
`

function SendToRevision() {
  const { data } = useProject()
  const { progress_status } = data
  return (
    <SendToRevisionStyled role="region" area-aria-labelledby="revision" started={!!progress_status}>
      <Wrapper maxWidth={1246}>
        <Typography as="h2" small="headline5" large="headline4" id="revision">
          Envía tu proyecto a revisión
        </Typography>
        <div className="sender-container">
          <div className="student-project-card">
            <ProjectCard {...data} />
          </div>
          <ol className="revision-steps">
            <li className="revision-step">
              <span>1.</span>
                Vincula un repositorio a tu proyecto
            </li>
            <li className="revision-step">
              <span>2.</span>
                Añade el Stack utilizado
            </li>
            <li className="revision-step">
              <span>3.</span>
                Añade una descripción
            </li>
            <li className="revision-step">
              <span>4.</span>
                Envíalo a revisión
            </li>
            <li className="revision-step">
              <span>5.</span>
                Espera Feedback
            </li>
          </ol>
        </div>
      </Wrapper>
    </SendToRevisionStyled>
  )
}

export default SendToRevision
